import { SITE_URL } from "./seo";
import { youtubeEmbedUrl, youtubeThumbnailUrl } from "./youtube";

type VideoSchemaOptions = {
  name: string;
  description: string;
  /** 11-char YouTube video ID. */
  youtubeId: string;
  /** ISO 8601 (e.g. "2026-06-25" or full timestamp). */
  uploadDate: string;
  /** Optional override; defaults to YouTube maxres thumbnail. */
  thumbnailUrl?: string;
  /** Optional ISO 8601 duration, e.g. "PT45S". */
  durationISO?: string;
  /** Optional contentUrl (defaults to canonical watch URL). */
  contentUrl?: string;
};

/**
 * Canonical VideoObject JSON-LD node. Links the video to the shared
 * RoofingContractor entity via publisher.@id so Google reconciles it
 * with the rest of the site's structured data.
 */
export function videoSchema(opts: VideoSchemaOptions): Record<string, unknown> {
  const node: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    name: opts.name,
    description: opts.description,
    thumbnailUrl: opts.thumbnailUrl ?? youtubeThumbnailUrl(opts.youtubeId),
    uploadDate: opts.uploadDate,
    embedUrl: youtubeEmbedUrl(opts.youtubeId),
    contentUrl: opts.contentUrl ?? `https://www.youtube.com/watch?v=${opts.youtubeId}`,
    publisher: { "@id": `${SITE_URL}/#business` },
  };
  if (opts.durationISO) node.duration = opts.durationISO;
  return node;
}
